import { useFormikContext } from "formik";

import { ReferencedTextAreaStandalone } from "../../../Components/ReferencedTextArea/ReferencedTextArea";
import { useReferencedFieldContext } from "../parameters/wrappers/ReferencedField/useReferencedFieldContext";
import { useFieldCommonProps } from "../useFieldCommonProps";
import { OptionalParamWrapper } from "./wrappers/OptionalParamWrapper";

export function ReferenceTextAreaParam({
  fieldPath,
  label,
  onRemove,
  renderAsNotRequired,
}: {
  fieldPath: string;
  label: string;
  onRemove?: () => void;
  renderAsNotRequired?: boolean;
}) {
  const formikProps = useFormikContext();
  const fieldProps = formikProps.getFieldProps(fieldPath);

  const { referenceableNodes } = useReferencedFieldContext();
  const commonFieldProps = useFieldCommonProps(fieldProps, label, onRemove === undefined && !renderAsNotRequired);

  return (
    <OptionalParamWrapper onRemove={onRemove}>
      <ReferencedTextAreaStandalone
        {...commonFieldProps}
        referenceableNodes={referenceableNodes}
        value={commonFieldProps.value}
        onChange={(e) => {
          formikProps.setFieldValue(fieldPath, e.target.value);
          formikProps.setFieldTouched(fieldPath);
        }}
        onBlur={() => {
          formikProps.setFieldTouched(fieldPath);
        }}
      />
    </OptionalParamWrapper>
  );
}
